import React from 'react';
import { Award, Star } from 'lucide-react';

const RecognitionTab = ({ recognitions, recognitionCategories, recognitionForm, setRecognitionForm, isLoading, submitRecognition }) => (
  <div className="space-y-6">
    {/* Recognition Form */}
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
        <Award className="w-5 h-5 mr-2 text-yellow-500" />
        Nominate Someone
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Recipient *
          </label>
          <input
            type="text"
            value={recognitionForm.recipient_id}
            onChange={(e) => setRecognitionForm(prev => ({ ...prev, recipient_id: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            placeholder="Employee ID or email"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Category
          </label>
          <select
            value={recognitionForm.category_id}
            onChange={(e) => setRecognitionForm(prev => ({ ...prev, category_id: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          >
            <option value="">Select Category</option>
            {recognitionCategories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-4">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Recognition Title *
        </label>
        <input
          type="text"
          value={recognitionForm.title}
          onChange={(e) => setRecognitionForm(prev => ({ ...prev, title: e.target.value }))}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          placeholder="What did they do great?"
        />
      </div>

      <div className="mt-4">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Message *
        </label>
        <textarea
          value={recognitionForm.message}
          onChange={(e) => setRecognitionForm(prev => ({ ...prev, message: e.target.value }))}
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          placeholder="Describe their achievement or contribution..."
        />
      </div>

      <div className="mt-4 flex justify-end">
        <button
          onClick={submitRecognition}
          disabled={isLoading}
          className="px-6 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 disabled:opacity-50 flex items-center"
        >
          <Award className="w-4 h-4 mr-2" />
          {isLoading ? 'Submitting...' : 'Submit Recognition'}
        </button>
      </div>
    </div>

    {/* Recognition Wall */}
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
        <Star className="w-5 h-5 mr-2 text-yellow-500" />
        Recognition Wall
      </h3>

      {recognitions.length === 0 ? (
        <div className="text-center py-8 text-gray-500 dark:text-gray-400">
          <Award className="w-12 h-12 mx-auto mb-4 text-gray-300" />
          <p>No recognitions yet</p>
          <p className="text-sm">Be the first to recognize someone's great work!</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {recognitions.map((recognition) => (
            <div key={recognition.id} className="border border-gray-200 dark:border-gray-600 rounded-md p-4">
              <div className="flex items-start gap-3">
                <Award className="w-8 h-8 text-yellow-500 flex-shrink-0" />
                <div className="flex-1">
                  <h4 className="font-medium text-gray-900 dark:text-white">
                    {recognition.title}
                  </h4>
                  <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">
                    {recognition.message}
                  </p>
                  <div className="mt-2 text-xs text-gray-500">
                    <span>To: {recognition.recipient_name || 'Anonymous'}</span>
                    <span className="mx-2">•</span>
                    <span>{new Date(recognition.created_at).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);

export default RecognitionTab;
